<template>
  <div>
    <label class="small-caps"
      >Project Owner{{ Object.keys(team.owners).length > 1 ? 's' : '' }}</label
    >
    <div class="grid">
      <data-select
        type="user"
        :changeHandler="updateProjectMembers"
        :filterIds="member_keys"
        arg="Owner"
        allowAdd
      />
      <data-select
        type="user"
        v-for="(owner, index) of team.owners"
        :key="`team-owner-${index}`"
        :changeHandler="updateProjectMembers"
        :value="owner"
        :filterIds="member_keys"
        arg="Owner"
        allowAdd
      />
    </div>

    <label class="small-caps"
      >Sponsor{{ Object.keys(team.sponsors).length > 1 ? 's' : '' }}</label
    >
    <div class="grid">
      <data-select
        type="user"
        :changeHandler="updateProjectMembers"
        :filterIds="member_keys"
        arg="Sponsor"
        allowAdd
      />
      <data-select
        type="user"
        v-for="(sponsor, index) of team.sponsors"
        :key="`team-sponsor-${index}`"
        :changeHandler="updateProjectMembers"
        :value="sponsor"
        :filterIds="member_keys"
        arg="Sponsor"
        allowAdd
      />
    </div>

    <label class="small-caps"
      >Key stakeholder{{
        Object.keys(team.members).length > 1 ? 's' : ''
      }}</label
    >
    <div class="grid">
      <data-select
        type="user"
        :changeHandler="updateProjectMembers"
        :filterIds="member_keys"
        arg="Team"
        allowAdd
      />
      <data-select
        type="user"
        v-for="(member, index) of team.members"
        :key="`team-member-${index}`"
        :changeHandler="updateProjectMembers"
        :value="member"
        :filterIds="member_keys"
        arg="Team"
        allowAdd
      />
    </div>

    <label class="small-caps">Other stakeholders</label>
    <div class="grid">
      <data-select
        type="user"
        :changeHandler="updateProjectMembers"
        :filterIds="member_keys"
        arg="Other"
        allowAdd
      />
      <data-select
        type="user"
        v-for="(other, index) of team.others"
        :key="`team-other-${index}`"
        :changeHandler="updateProjectMembers"
        :value="other"
        :filterIds="member_keys"
        arg="Other"
        allowAdd
      />
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import DataSelect from './DataSelect.vue';

export default {
  name: 'ProjectModal_Team',
  props: {
    project: Object,
  },
  computed: {
    project_id() {
      return this.$store.getters.project_modal_id;
    },
    app_user() {
      return this.$store.getters.app_user;
    },
    users() {
      return this.$store.getters.users;
    },
    member_keys() {
      if (!this.project || !this.project.projectMembers) return [];
      return this.project.projectMembers.map(member => member.userId);
    },
    project_members() {
      if (!this.project || !this.project.projectMembers) return [];
      return this.project.projectMembers;
    },
  },
  data() {
    return {
      team: {
        owners: {},
        sponsors: {},
        members: {},
        others: {},
      },
      new_project: true,
    };
  },
  components: {
    'data-select': DataSelect,
  },
  methods: {
    async updateProjectMembers(user, mode, type, old_value) {
      user.type = type;

      if (mode === 'add' && old_value) {
        let ind;
        this.project.projectMembers.forEach((member, index) => {
          if (member.userId === old_value.userId) {
            ind = index;
          }
        });

        Vue.set(this.project.projectMembers, ind, user);
      } else if (mode === 'add') {
        this.project.projectMembers.push(user);
      } else {
        if(mode === 'remove' && (user.userId === this.$store.getters.app_user.id && this.project.private)) {
          const options = {
            html: false,
            okText: 'Cancel',
            customClass: 'acada-confirm',
            animation: 'fade',
          };

          const message = {
            title: `Can't remove team member`,
            body: 'This is a private project, removing yourself will cause you to lose project access',
          };

          await this.$dialog.alert(message, options);
          return;
        }
        this.project.projectMembers = this.project.projectMembers.filter(
          member => member.userId !== user.userId
        );
      }
    },
    reset() {
      this.team = {
        owners: {},
        sponsors: {},
        members: {},
        others: {},
      };
    },
  },
  watch: {
    project_id() {
      this.reset();
      if (this.project_id === -1) {
        this.new_project = true;
      }
    },
    project_members() {
      if (!this.project || !this.project.projectMembers) {
        return;
      }

      this.team = {
        owners: {},
        sponsors: {},
        members: {},
        others: {},
      };

      // make the current user the project owner, if this is a new project
      const me = this.users[this.app_user.id];
      if (
        me.role !== 'SuperAdmin' &&
        this.project_id === -1 &&
        this.new_project
      ) {
        this.updateProjectMembers(me, 'add', 'Owner');
        this.new_project = false;
      }

      this.project.projectMembers.forEach(member => {
        const id = String(member.id);
        const type = member.type.toLowerCase();

        switch (type) {
          case 'owner':
            this.team.owners[id] = member;
            break;
          case 'sponsor':
            this.team.sponsors[id] = member;
            break;
          case 'team':
            this.team.members[id] = member;
            break;
          case 'other':
          default:
            this.team.others[id] = member;
            break;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/_styles.scss';
</style>
